module.exports = {
  title: 'Spex – das neue Hip-Hop-Festival in Bern (21.–22. Juli 2023)',
  // eslint-disable-next-line
  description:
    // eslint-disable-next-line max-len
    'Mit angesagten regionalen, nationalen und internationalen Künstler:innen aus dem Bereich Hip-Hop. Die ersten Acts werden im Herbst angekündigt. Stay tuned!',
  debugMode: false,
  logRedirects: false,
  // be sure to not add any / at the end of URL
  url: {
    dev: 'http://localhost:3333',
    prod: 'https://spexfestival.ch'
  },
  api: {
    // TODO: convert to projectId: process.env.SANITY_PROJECT_ID
    projectId: 'kiik983o',
    // dataset: process.env.NODE_ENV === 'production'
    //   ? 'production'
    //   : 'develop',
    dataset: 'production',
    // Add current date to fix the data api version. This avoids breaking changes over the time.
    apiVersion: '2021-10-11',
    useCdn: true
  },
  modules: {
    // TODO: Webfontloader: https://github.com/Developmint/nuxt-webfontloader
    googleTagManager: {
      active: true,
      id: 'G-9R4Z8YHYFB'
    },
    sendgrid: {
      active: true,
      id: process.env.SENDGRID_ID
    },
    cookieConsent: {
      active: true,
      position: 'br', // tl = topleft, tr = topright, bl = bottomleft, br = bottomright
      transition: 'fl' // fd = fade, ft = fromTop, fl = fromLeft, fb = fromBottom, fr = fromRight
    }
  },
  mixins: {
    setDevmode: true,
    setViewportSizes: false
  },
  i18n: {
    baseUrl:
      process.env.NODE_ENV === 'production' ? 'https://spex.vercel.app/' : 'http://localhost:3333/',
    strategy: 'prefix_except_default',
    langDir: '~/locales/',
    vuex: {
      moduleName: 'i18n',
      syncRouteParams: true
    },
    locales: [
      {
        code: 'de',
        iso: 'de',
        file: 'de.json'
      }
    ],
    defaultLocale: 'de',
    detectBrowserLanguage: {
      useCookie: true,
      cookieKey: 'i18n_redirected',
      fallbackLocale: 'de',
      redirectOn: 'root'
    }
  }
};
